import { render, staticRenderFns } from "./CampaignPopup.vue?vue&type=template&id=2b4f8e6a&"
import script from "./CampaignPopup.vue?vue&type=script&lang=js&"
export * from "./CampaignPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports